import React, { Suspense, useEffect, useState } from "react";
import "App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "components/Navbar";
import MainContext from "context/MainContext";
import ToastContaier from "ui/ToastContaier/ToastContaier";
import MediaGallery from "components/MediaGallery/MediaGallery";
import ModalEventCalendar from "components/ModalEventCalendar/ModalEventCalendar";
import { getLogged } from "api/functions/functions";
import { IMAGES } from "config/mime";
import Login from "layouts/Login/Login";
import { getAuthToken, goToLoginPage, initPusher } from "utils/functions";
import AboutLayout from "layouts/AboutLayout/AboutLayout";
import Toast from "ui/Toast/Toast";
import moment from "moment";
import { Loading } from "carbon-components-react";
import ModalTestPlayer from "modals/ModalTestPlayer/ModalTestPlayer";
import ModalChangePasswordForm from "modals/ModalChangePasswordForm/ModalChangePasswordForm";
import ModalCheckBuyDomain from "modals/ModalCheckBuyDomain/ModalCheckBuyDomain";

const EventLayout = React.lazy(() => import("layouts/EventLayout"));
const EventsLayout = React.lazy(() =>
    import("layouts/EventsLayout/EventsLayout")
);
const SpeakersLayout = React.lazy(() =>
    import("layouts/SpeakersLayout/SpeakersLayout")
);
const DomainsLayout = React.lazy(() =>
    import("layouts/DomainsLayout/DomainsLayout")
);
const CalendarLayout = React.lazy(() =>
    import("layouts/CalendarLayout/CalendarLayout")
);
const UsersLayout = React.lazy(() => import("layouts/UsersLayout/UsersLayout"));
const LogsLayout = React.lazy(() => import("layouts/LogsLayout/LogsLayout"));

// const MainContext = React.createContext({
//   theme: "dark",
// });

function App() {
    const [evt, setEvt] = useState({});
    const [user, setUser] = useState({});
    const [users, setUsers] = useState([]);
    const [toasts, setToasts] = useState([]);
    const [episode, setEpisode] = useState();
    const [episodeId, setEpisodeId] = useState();

    const [online, setOnline] = useState(true);

    const [primaryColor, setPrimaryColor] = useState();
    const [secondaryColor, setSecondaryColor] = useState();
    const [tertiaryColor, setTertiaryColor] = useState();

    const [mediaGalleryOpen, setMediaGalleryOpen] = useState(false);
    const [mediaGalleryAttachParams, setMediaGalleryAttachParams] =
        useState(null);
    const [mediaGalleryAttached, setMediaGalleryAttached] = useState([]);
    const [mediaGalleryActiveSection, setMediaGalleryActiveSection] =
        useState();
    const [mediaGalleryAccept, setMediaGalleryAccept] = useState(IMAGES);
    const [mediaGalleryClearOnClose, setMediaGalleryClearOnClose] =
        useState(true);
    const [mediaGalleryFilters, setMediaGalleryFilters] = useState({});
    const [mediaGalleryOnAttach, setMediaGalleryOnAttach] = useState();
    const [mediaGalleryWithPermission, setMediaGalleryWithPermission] =
        useState();

    const [checkContentsCounter, setCheckContentsCounter] = useState(0);
    const [secondarySidebarListItems, setSecondarySidebarListItems] = useState(
        []
    );
    const [secondarySidebarListItemsBeta, setSecondarySidebarListItemsBeta] =
        useState([]);
    const [modalCalendarFormOpen, setModalCalendarFormOpen] = useState(false);
    const [modalCalendarType, setModalCalendarType] = useState();
    const [secondaryNavFront, setSecondaryNavFront] = useState(false);
    // const [afterAttachChange, setAfterAttachChange] = useState()
    const [deliveredCoa, setDeliveredCoa] = useState([]);
    // const [notifications, setNotifications] = useState([])
    const [pusherPrivateChannel, setPusherPrivateChannel] = useState();

    const [modalLayoutFormOpen, setModalLayoutFormOpen] = useState(false);
    const [selectedCalendar, setSelectedCalendar] = useState();
    const [selectedCalendarId, setSelectedCalendarId] = useState();
    const [createNewCalendar, setCreateNewCalendar] = useState(false);
    const [calendarParentId, setCalendarParentId] = useState();
    const [calendarParentType, setCalendarParentType] = useState();
    const [calendarFormOnSubmit, setCalendarFormOnSubmit] = useState();

    const [loadingEventData, setLoadingEventData] = useState(false);
    const [browserAlert, setBrowserAlert] = useState(false);

    const [modalTestPlayerOpen, setModalTestPlayerOpen] = useState(false);
    const [modalTestPlayerSource, setModalTestPlayerSource] = useState("");

    const [modalCheckBuyDomainOpen, setModalCheckBuyDomainOpen] =
        useState(false);
    const [modalCheckBuyDomainOk, setModalCheckBuyDomainOk] = useState(false);
    const [modalCheckBuyDomainValue, setModalCheckBuyDomainValue] = useState();

    const [passwordExpired, setPasswordExpired] = useState(false);
    const [passwordExpiredModalOpen, setPasswordExpiredModalOpen] =
        useState(false);
    const [passwordExpiredModalMandatory, setPasswordExpiredModalMandatory] =
        useState(true);
    const [isImportFinished, setIsImportFinished] = useState(false)
    const [isPublicQAOpen, setIsPublicQAOpen] = useState(false)

    const [isPusherOnline, setIsPusherOnline] = useState(false)

    const [userNotifications, setUserNotifications] = useState()

    const [awsApps, setAwsApps] = useState([])

    useEffect(() => {
        const re = new RegExp(/(login|logout)/);
        const isLoginPage = re.test(window.location.pathname);
        const token = getAuthToken();
        detectBrowser();
        async function fetchData() {
            try {
                const res = await getLogged();
                if (res) {
                    setUser(res);
                    window.Pusher = initPusher();
                    const pusherChannel = subscribeToChannel(res.id);
                    // pusherChannel.bind("App\\Events\\UpdateNotifications", (data) => {
                    pusherChannel.bind(
                        "Illuminate\\Notifications\\Events\\BroadcastNotificationCreated",
                        (data) => {
                            // alert(data.message)
                            addToast(
                                {
                                    key: moment().format("X"),
                                    title: data.title,
                                    subtitle: data.message,
                                    kind: data.kind,
                                }
                                // <Toast title={data.message} key={moment().format()} />
                            );

                            setUserNotifications(notifications => {
                                return [
                                    ...notifications,
                                    {
                                        data: {
                                            kind: data?.kind,
                                            message: data?.message,
                                            title: data?.title
                                        },
                                        id: data?.id,
                                        type: data?.type
                                    },
                                ]
                            })
                        }
                    );

                    window.Pusher.connection.bind(
                        "state_change",
                        function (status) {
                            if (status.current === "connected") {
                                setIsPusherOnline(true)
                            } else {
                                setIsPusherOnline(false)
                            }
                        }
                    );

                    window.Pusher.connection.bind(
                        "pusher:subscription_error",
                        function (err) {
                            console.error("pusher:subscription_error: ", err)
                        }
                    );

                    window.Pusher.connection.bind("error", function (err) {
                        console.error("pusher:error: ", err)
                    });

                    setPusherPrivateChannel(pusherChannel);
                    setUserNotifications(res.notifications)
                }
            } catch (e) {
                if (!isLoginPage) {
                    if (e.response.status === 461) {
                        setPasswordExpired(true);
                        setPasswordExpiredModalOpen(true);
                    } else {
                        goToLoginPage();
                    }
                }
            }
        }
        addListeners();
        if (!isLoginPage && !token) {
            goToLoginPage();
        } else if (token) {
            fetchData();
        }
        return () => {
            unsubscribeFromChannel(user.id);
        };
    }, []);

    useEffect(() => {
        setEpisode(
            evt?.episodes?.find((item) => item.id === parseInt(episodeId))
        );
    }, [episodeId, evt]);

    const subscribeToChannel = (userId) => {
        return window.Pusher.subscribe("private-users." + userId);
    };
    const unsubscribeFromChannel = (userId) => {
        window.Pusher.unsubscribe("private-users." + userId);
    };

    const addListeners = () => {
        // Detect when user's connection is OK
        window.ononline = (event) => {
            // alert("You are now connected to the network.");
            setOnline(true);
        };
        // Detect when user's connection is broken
        window.onoffline = (event) => {
            // alert("The network connection has been lost.");
            setOnline(false);
        };
    };

    const detectBrowser = () => {
        let verOffset = navigator.userAgent.indexOf("Chrome");
        if (verOffset === -1) {
            setBrowserAlert(true);
        }
    };

    const addToast = (taost) => {
        setToasts((toasts) => {
            return [taost, ...toasts];
        });
    };

    const removeToastFromList = (key) => {
        if (!key) return;
        setToasts((toasts) => {
            return toasts.filter(
                (singleToast) => singleToast?.key?.toString() !== key
            );
        });
    };

    const getToasts = () => {
        return toasts?.map((toastData) => {
            return (
                <Toast
                    keyId={toastData.key}
                    kind={toastData.kind}
                    title={toastData.title}
                    subtitle={toastData.subtitle}
                    onCloseToast={(key) => removeToastFromList(key)}
                />
            );
        });
    };

    const onChangePasswordClicked = () => {
        setPasswordExpiredModalMandatory(false);
        setPasswordExpiredModalOpen(true);
    };

    const closeChangePasswordModal = (goToLogin = false) => {
        if (goToLogin) {
            goToLoginPage();
        }
        setPasswordExpiredModalOpen(false);
        setPasswordExpiredModalMandatory(true);
    };

    const onPasswordChanged = () => {
        closeChangePasswordModal(true);
    };

    return (
        <div className="App">
            <MainContext.Provider
                value={{
                    theme: "dark",
                    evt: evt,
                    episode: episode,
                    episodeId: episodeId,
                    user: user,
                    toasts: toasts,
                    checkContentsCounter: checkContentsCounter,

                    online: online,
                    pusherPrivateChannel: pusherPrivateChannel,
                    mediaGalleryOpen: mediaGalleryOpen,
                    mediaGalleryAttachParams: mediaGalleryAttachParams,
                    mediaGalleryAttached: mediaGalleryAttached,
                    mediaGalleryActiveSection: mediaGalleryActiveSection,
                    mediaGalleryAccept: mediaGalleryAccept,
                    mediaGalleryClearOnClose: mediaGalleryClearOnClose,
                    mediaGalleryFilters: mediaGalleryFilters,
                    mediaGalleryOnAttach: mediaGalleryOnAttach,
                    mediaGalleryWithPermission: mediaGalleryWithPermission,
                    loadingEventData,

                    secondarySidebarListItems: secondarySidebarListItems,
                    secondarySidebarListItemsBeta:
                        secondarySidebarListItemsBeta,
                    primaryColor: primaryColor,
                    secondaryColor: secondaryColor,
                    tertiaryColor: tertiaryColor,
                    modalCalendarFormOpen: modalCalendarFormOpen,
                    modalCalendarType: modalCalendarType,
                    secondaryNavFront: secondaryNavFront,
                    deliveredCoa: deliveredCoa,
                    selectedCalendar,
                    selectedCalendarId,
                    createNewCalendar,
                    calendarParentId,
                    calendarParentType,
                    modalLayoutFormOpen,
                    users,
                    calendarFormOnSubmit,
                    modalTestPlayerOpen,
                    modalTestPlayerSource,
                    modalCheckBuyDomainOpen,
                    modalCheckBuyDomainOk,
                    modalCheckBuyDomainValue,
                    isImportFinished,
                    isPublicQAOpen,
                    isPusherOnline,
                    isStagingAndUserNotAdmin: process.env.REACT_APP_ENV === "staging" && !user?.is_admin,
                    userNotifications: userNotifications,
                    awsApps,
                    env: {
                        dev: process.env.REACT_APP_ENV === "local",
                        staging: process.env.REACT_APP_ENV === "staging",
                        production: process.env.REACT_APP_ENV === "production"
                    },

                    // afterAttachChange: afterAttachChange,
                    setCheckContentsCounter: (newcheckContentsCounter) =>
                        setCheckContentsCounter(newcheckContentsCounter),
                    setMediaGalleryOpen: (newMediaGalleryOpenValue) =>
                        setMediaGalleryOpen(newMediaGalleryOpenValue),
                    setMediaGalleryAttachParams: (
                        mediaGalleryAttachParamsValue
                    ) =>
                        setMediaGalleryAttachParams(
                            mediaGalleryAttachParamsValue
                        ),
                    setMediaGalleryAttached: (mediaGalleryAttachedValue) =>
                        setMediaGalleryAttached(mediaGalleryAttachedValue),
                    setMediaGalleryActiveSection: (newValue) =>
                        setMediaGalleryActiveSection(newValue),
                    setMediaGalleryAccept: (newValue) =>
                        setMediaGalleryAccept(newValue),
                    setMediaGalleryClearOnClose: (newValue) =>
                        setMediaGalleryClearOnClose(newValue),
                    setMediaGalleryFilters: (newValue) =>
                        setMediaGalleryFilters(newValue),
                    setMediaGalleryOnAttach: (newValue) =>
                        setMediaGalleryOnAttach(newValue),
                    setMediaGalleryWithPermission: (newValue) =>
                        setMediaGalleryWithPermission(newValue),

                    setSecondarySidebarListItems: (
                        newSecondarySidebarListItemsValue
                    ) =>
                        setSecondarySidebarListItems(
                            newSecondarySidebarListItemsValue
                        ),
                    setSecondarySidebarListItemsBeta: (
                        newSecondarySidebarListItemsValue
                    ) =>
                        setSecondarySidebarListItemsBeta(
                            newSecondarySidebarListItemsValue
                        ),
                    // setAfterAttachChange: (newAfterAttachChange) => setAfterAttachChange(newAfterAttachChange),
                    setModalCalendarFormOpen: (value) =>
                        setModalCalendarFormOpen(value),
                    setModalCalendarType: (value) =>
                        setModalCalendarType(value),
                    setSecondaryNavFront: (value) =>
                        setSecondaryNavFront(value),
                    setDeliveredCoa: (value) => setDeliveredCoa(value),

                    setEvent: (eventData) => setEvt(eventData),
                    setEpisodeId: (newEpisodeId) => setEpisodeId(newEpisodeId),
                    addToast: (toast) => addToast(toast),
                    setPrimaryColor: (color) => setPrimaryColor(color),
                    setSecondaryColor: (color) => setSecondaryColor(color),
                    setTertiaryColor: (color) => setTertiaryColor(color),
                    setUsers: (users) => setUsers(users),
                    setModalLayoutFormOpen: (value) =>
                        setModalLayoutFormOpen(value),
                    setSelectedCalendar: (value) => setSelectedCalendar(value),
                    setSelectedCalendarId: (value) =>
                        setSelectedCalendarId(value),
                    setCreateNewCalendar: (value) =>
                        setCreateNewCalendar(value),
                    setCalendarParentId: (value) => setCalendarParentId(value),
                    setCalendarParentType: (value) =>
                        setCalendarParentType(value),
                    setLoadingEventData: (value) => setLoadingEventData(value),
                    setCalendarFormOnSubmit: (callback) =>
                        setCalendarFormOnSubmit(callback),
                    setModalTestPlayerOpen: (value) =>
                        setModalTestPlayerOpen(value),
                    setModalTestPlayerSource: (value) =>
                        setModalTestPlayerSource(value),
                    setModalCheckBuyDomainOpen: (value) =>
                        setModalCheckBuyDomainOpen(value),
                    setModalCheckBuyDomainOk: (value) =>
                        setModalCheckBuyDomainOk(value),
                    setModalCheckBuyDomainValue: (value) =>
                        setModalCheckBuyDomainValue(value),

                    setIsImportFinished: (value) =>
                        setIsImportFinished(value),

                    setIsPublicQAOpen: (value) =>
                        setIsPublicQAOpen(value),
                    setIsPusherOnline: (isOnline) =>
                        setIsPusherOnline(isOnline),

                    setUserNotifications: (notifications) =>
                        setUserNotifications(notifications),

                    setAwsApps: (awsApps) => setAwsApps(awsApps)
                }}
            >
                <Router>
                    <ToastContaier>{getToasts()}</ToastContaier>
                    <Navbar
                        online={online}
                        user={user}
                        event={evt}
                        browserAlert={browserAlert}
                        onChangePasswordClicked={onChangePasswordClicked}
                    />
                    <Suspense fallback={<Loading />}>
                        <Switch>
                            {/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}

                            {/* <Route exact path="/">
              <Home />
            </Route> */}
                            <Route path="/login" exact>
                                <Login />
                            </Route>
                            <Route path="/events" exact>
                                <EventsLayout />
                            </Route>
                            <Route path="/domains" exact>
                                <DomainsLayout />
                            </Route>
                            <Route path="/calendar" exact>
                                <CalendarLayout />
                            </Route>
                            <Route path="/about" exact>
                                <AboutLayout />
                            </Route>
                            <Route path="/speakers" exact>
                                <SpeakersLayout />
                            </Route>
                            <Route path="/logs">
                                <LogsLayout />
                            </Route>
                            <Route path="/configs">
                                <UsersLayout />
                            </Route>
                            <Route path="/events/:event">
                                <EventLayout />
                            </Route>
                            <Route path="*">
                                <EventsLayout />
                            </Route>
                        </Switch>
                    </Suspense>
                    <MediaGallery />
                    <ModalEventCalendar />
                    <ModalTestPlayer />
                    <ModalCheckBuyDomain />
                    <ModalChangePasswordForm
                        open={passwordExpiredModalOpen}
                        onClose={closeChangePasswordModal}
                        closable={!passwordExpiredModalMandatory}
                        onPasswordChanged={onPasswordChanged}
                    />
                </Router>
            </MainContext.Provider>
        </div>
    );
}

export default App;
